import { render, staticRenderFns } from "./ProgramListLoader.vue?vue&type=template&id=20279151&scoped=true"
import script from "./ProgramListLoader.vue?vue&type=script&lang=js"
export * from "./ProgramListLoader.vue?vue&type=script&lang=js"
import style0 from "./ProgramListLoader.vue?vue&type=style&index=0&id=20279151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20279151",
  null
  
)

export default component.exports